module.exports = __webpack_public_path__ + "img/shake_bg.7cc240c6.jpg";